import { Component, OnInit, ViewChild } from '@angular/core';
import { WebContentSearchGridComponent } from '../web-content-search-grid/web-content-search-grid.component';
import { WebContentSearchDto } from '../shared/dto/web-content-search.dto';
import { UserService } from '../../users/shared/user.service';

@Component({
  selector: 'wl-manage-web-content',
  templateUrl: './manage-web-content.component.html',
  styleUrls: ['./manage-web-content.component.less'],
    standalone: false
})
export class ManageWebContentComponent implements OnInit {
  @ViewChild(WebContentSearchGridComponent) private _webContentGridComponent: WebContentSearchGridComponent;
  webContentSearchParams = new WebContentSearchDto(0, true);
  isReadOnly = true

  constructor(
    private _userService: UserService,
  ) {}

  ngOnInit(): void {
    let p8: any = this._userService.getCurrentUserSecurityElementAccessLevel('Web_Content_Management').then((accessLevel: number) => {
      if(accessLevel == 2)
      this.isReadOnly = false;
    })
    this.webContentSearchParams.PageSize = 20;
  }

  search() {
    if (this._webContentGridComponent) {
      this._webContentGridComponent.getWebContents();
    }
  }

  clear() {
    this.webContentSearchParams = new WebContentSearchDto();
    this.webContentSearchParams.PageSize = 20;
    setTimeout(() => {
      this.search();
    }, 250);
  }
}
